"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _MaterialIcon = _interopRequireDefault(require("../MaterialIcon"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Text = _interopRequireDefault(require("../Text"));
var _styledComponents = require("styled-components");
var _Hooks = require("../Hooks");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Dropdown = _ref => {
  let {
    color: propColor,
    fontSize = '13px',
    options = [],
    position = 'right',
    size = 15,
    text,
    top = '0px',
    width = '200px'
  } = _ref;
  const {
    disabledColor,
    textColor
  } = (0, _styledComponents.useTheme)();
  const color = propColor !== null && propColor !== void 0 ? propColor : textColor;
  const [isActive, toggleIsActive, setIsActive] = (0, _Hooks.useToggle)(false);
  const containerProps = {
    as: 'div',
    color,
    'data-testid': 'dropdown-container',
    onClick: toggleIsActive
  };
  const iconProps = {
    color,
    icon: isActive ? 'expand_less' : 'expand_more',
    size
  };
  const menuProps = {
    left: position === 'left',
    right: position === 'right',
    top,
    width
  };
  const textProps = {
    color,
    fontSize,
    margin: '0px 5px 0px 0px'
  };
  const handleClick = (e, onClick, item) => {
    e.stopPropagation();
    setIsActive(false);
    onClick && onClick(item);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: [!!text && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, _objectSpread(_objectSpread({}, textProps), {}, {
      children: text
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, _objectSpread({}, iconProps)), isActive && /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.DropdownContainer, _objectSpread(_objectSpread({}, menuProps), {}, {
      children: options.map((item, index) => {
        const {
          disabled,
          display = true,
          icon,
          iconColor,
          label,
          onClick
        } = item;
        if (!display) return null;
        const iconProps = {
          color: disabled ? disabledColor : iconColor !== null && iconColor !== void 0 ? iconColor : textColor,
          icon,
          margin: '0px 5px 0px 0px',
          size: 16
        };
        const textProps = {
          color: disabled ? disabledColor : textColor,
          fontSize
        };
        const itemProps = {
          disabled
        };
        return /*#__PURE__*/(0, _react.createElement)(_styled.DropdownItem, _objectSpread(_objectSpread({}, itemProps), {}, {
          key: "dropdwon-item-".concat(index),
          onClick: e => handleClick(e, onClick, item)
        }), !!icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MaterialIcon.default, _objectSpread({}, iconProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, _objectSpread(_objectSpread({}, textProps), {}, {
          children: label
        })));
      })
    }))]
  }));
};
Dropdown.propTypes = {
  color: _propTypes.default.string,
  fontSize: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    disabled: _propTypes.default.bool,
    display: _propTypes.default.bool,
    icon: _propTypes.default.string,
    iconColor: _propTypes.default.string,
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  })),
  position: _propTypes.default.oneOf(['left', 'right']),
  size: _propTypes.default.number,
  text: _propTypes.default.string,
  top: _propTypes.default.string,
  width: _propTypes.default.string
};
var _default = exports.default = Dropdown;